module.exports = __webpack_public_path__ + "static/logo-69eda866d47b82fdbca5efd4350c8747.png";